export const STRENGTH_OBJECTIVE_TEMPLATES = ['preparation', 'development', 'maintenance'] as const;
export type StrengthObjectiveTemplate = typeof STRENGTH_OBJECTIVE_TEMPLATES[number];
